import { useDynamicssalesListOpportunityLinkQuery } from "@/services/backend/dynamics/api/process-match";

export function useOpportunityLinkList(processId: string) {
  const { data: list, isLoading } = useDynamicssalesListOpportunityLinkQuery({
    processId,
  });
  return { list: list, isLoading };
}
